import { Link } from "react-router-dom";
import styled from "styled-components";
import { Star } from "lucide-react";

const theme = {
  colors: {
    textMuted: "#6b7280",
    primary: "#3b82f6",
  },
};

const RatingLink = styled(Link)`
  display: inline-flex;
  align-items: center;
  gap: 3px;
  font-size: 0.8rem;
  color: ${theme.colors.textMuted};
  text-decoration: none;
  cursor: pointer;

  &:hover {
    color: ${theme.colors.primary};
  }

  svg {
    width: 12px;
    height: 12px;
    color: #f59e0b;
    fill: #f59e0b;
  }
`;

/**
 * UserRating - Displays a clickable star rating that links to user's reviews
 *
 * @param {number} userId - The user's ID
 * @param {number} averageRating - The user's average rating (1-5)
 * @param {number} totalReviews - Total number of reviews
 * @param {object} style - Optional inline styles
 */
const UserRating = ({ userId, averageRating, totalReviews, style }) => {
  if (!totalReviews || totalReviews <= 0) {
    return null;
  }

  return (
    <RatingLink to={`/users/${userId}#reviews`} style={style}>
      <Star />
      {averageRating?.toFixed(1)} ({totalReviews})
    </RatingLink>
  );
};

export default UserRating;
